<app-record-page
  [moduleId]="4"
  [recordId]="itemCode"
  [BPCardCode]="CardCode"
  [inDrawer]="inDrawer"
  [actionType]="'View'"
  [fromDraft]="false"
  [showCommunication]="false"
  [isTokenized]="isTokenized"
  [footerAtTop]="footerAtTop"
  [additionalSectionsIndex]="1"
  (backButtonClicked)="backButtonClicked()"
  (objectSubmitted)="linkedObjectSubmitted($event)"
>
  <ng-container additionalSections >
    <nz-collapse nzGhost>
      <nz-collapse-panel
        *ngFor="let panelKey of relationPanels.keys()"
        [nzHeader]="panelKey"
        nzActive="true"
      >
        <nz-radio-group [(ngModel)]="isTable">
          <label nz-button nz-radio-button [nzValue]="true" nzType="primary">
            <i class="fal fa-table"></i>&nbsp;&nbsp;
            {{ "List" | locale }}
          </label>
          <label nz-radio-button [nzValue]="false">
            <i class="fal fa-grid"></i>&nbsp;&nbsp;
            {{ "Cards" | locale }}
          </label>
        </nz-radio-group>
        <app-cart-products
          [products]="relationPanels.get(panelKey)"
          [cart]="cart"
          [isTable]="isTable"
          [CardCode]="CardCode"
          [TableColumns]="TableColumns"
          [DocEntry]="shoppingCartId"
          [customer]="customer"
        >
        </app-cart-products>
      </nz-collapse-panel>
    </nz-collapse>
  </ng-container>
</app-record-page>
